import { parseListDate } from "helpers/parseListDate";
import { NCRCategoryRow } from "./NCRCategoryList.types";

export const formatNCRCategoryRow = (
  row: NCRCategoryRow
): { [K in keyof typeof row]: React.ReactNode } => {
  let formattedRow: any = { ...row };

  if (formattedRow.ncrCategoryTypes__AddDate) {
    formattedRow = {
      ...formattedRow,
      ncrCategoryTypes__AddDate: parseListDate(formattedRow.ncrCategoryTypes__AddDate, true),
    };
  }
  if (formattedRow.ncrCategoryTypes__EditDate) {
    formattedRow = {
      ...formattedRow,
      ncrCategoryTypes__EditDate: parseListDate(formattedRow.ncrCategoryTypes__EditDate, true),
    };
  }

  return formattedRow;
};
